import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import './HonorsItem.less';

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface HonorsItem {
    delay: number;
    src: string;
    desc: string;
    en: string;
    language: string;
}

const HonorsItem: React.FC<HonorsItem>= ({delay, src, desc, en, language}) => {
   const { t } = useTranslation();


  const boxVariant = {
    visible: { opacity: 1, translateY: 0, transition: { duration: 1, delay: delay } },
    hidden: { opacity: 0, translateY: 100 }
  };

   const control = useAnimation();
   const [ref, inView] = useInView();

   useEffect(() => {
      if (inView) {
        control.start("visible");
      } else {
        control.start("hidden");
      }
    }, [control, inView]);

    return(
      <motion.div
              ref={ref}
              variants={boxVariant}
              initial="hidden"
              animate={control}
            >
         <div className="homePage__honorsItem">
                <div className="homePage__honorsItemCert">
                    <img src={src} alt="" className="homePage__honorsItemCert-img" />
                </div>
                <div className={language === 'en' ? "homePage__honorsItemDesc en" : "homePage__honorsItemDesc"}>{language === 'en' ? en : desc }</div>
            </div> 
      </motion.div>
      
    )
}

export default HonorsItem;